import { Route, Routes, useLocation } from 'react-router-dom';
import { PATHS } from 'commons/paths';
import { Login } from 'pages/Login';
import { ConfirmMfaCode } from 'pages/ConfirmMfaCode';
import { ChangePassword } from 'pages/ChangePassword';
import { ResetPassword } from 'pages/ResetPassword';
import { ConfirmResetPassword } from 'pages/ConfirmResetPassword';
import { AuditionFormTop } from 'pages/AuditionFormTop';
import { MyPageTop } from 'pages/MyPageTop';
import { AuditionInfo } from 'pages/AuditionInfo';
import { RecruitingAuditions } from 'pages/RecruitingAuditions';
import { Message } from 'pages/Message';
import { NotFound } from 'pages/404';
import { Faq } from 'pages/Faq';
import { AppContext, AppContextProvider } from 'templates/AppContextProvider';
import { UserEdit } from './pages/UserEdit';
import { UserDelete } from './pages/UserDelete';
import { LoginError } from 'pages/LoginError';
import { AboutMfaCodeSending } from 'pages/AboutMfaCodeSending';
import { ThemeProvider } from '@mui/material/styles';
import { FC, PropsWithChildren, useContext, useEffect } from 'react';
import { theme } from 'theme';
import 'flag-icons/css/flag-icons.min.css';
import { Inquiry } from 'pages/Inquiry';
import { ConsentFormUpload } from 'pages/u002/ConsentFormUpload';
import { ForgetUserId } from 'pages/ForgetUserId';
import { ConsentReAgreement } from 'pages/ConsentReAgreement';
import { PrivacyNotice } from 'pages/PricacyNotice';

const DarkThemeProvider: FC<PropsWithChildren> = (props) => {
  const { darkMode } = useContext(AppContext);

  const _theme = darkMode ? theme.darkTheme : theme.lightTheme;

  return <ThemeProvider theme={_theme}>{props.children}</ThemeProvider>;
};

const ScrollReset = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <AppContextProvider>
      <DarkThemeProvider>
        <ScrollReset />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path={PATHS.CONFIRM_MFA_CODE} element={<ConfirmMfaCode />} />
          <Route path={PATHS.LOGIN_ERROR} element={<LoginError />} />
          <Route path={PATHS.ABOUT_MFA_CODE_SENDING} element={<AboutMfaCodeSending />} />
          <Route path={PATHS.AUDITION_FORM} element={<AuditionFormTop />} />
          <Route path={PATHS.CONSENT_FORM_UPLOAD} element={<ConsentFormUpload />} />
          <Route path={PATHS.MYPAGE} element={<MyPageTop />} />
          <Route path={PATHS.CHANGE_PASSWORD} element={<ChangePassword />} />
          <Route path={PATHS.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={PATHS.CONFIRM_RESET_PASSWORD} element={<ConfirmResetPassword />} />
          <Route path={PATHS.MYPAGE} element={<MyPageTop />} />
          <Route path={`${PATHS.AUDITION_INFO}/:audition_id`} element={<AuditionInfo />} />
          <Route path={PATHS.RECRUITING_AUDITIONS} element={<RecruitingAuditions />} />
          <Route path={`${PATHS.MESSAGE}/:audition_id`} element={<Message />} />
          <Route path={PATHS.USER_EDIT} element={<UserEdit />} />
          <Route path={PATHS.USER_DELETE} element={<UserDelete />} />
          <Route path={PATHS.NOT_FOUND} element={<NotFound />} />
          <Route path={PATHS.FAQ} element={<Faq />} />
          <Route path={PATHS.INQUIRY} element={<Inquiry />} />
          <Route path={PATHS.FORGET_USER_ID} element={<ForgetUserId />} />
          <Route path={PATHS.PRIVACY_NOTICE} element={<PrivacyNotice />} />
        </Routes>
        <ConsentReAgreement />
      </DarkThemeProvider>
    </AppContextProvider>
  );
}

export default App;
